// Canadian provinces and major cities for structured service-area selection.
// MOVD currently serves BC and Alberta; the remaining provinces are included so
// long-distance destinations can be selected without free text.

export const PROVINCES = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'British Columbia' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'ON', name: 'Ontario' },
  { code: 'QC', name: 'Quebec' },
  { code: 'NB', name: 'New Brunswick' },
  { code: 'NS', name: 'Nova Scotia' },
  { code: 'PE', name: 'Prince Edward Island' },
  { code: 'NL', name: 'Newfoundland and Labrador' },
  { code: 'YT', name: 'Yukon' },
  { code: 'NT', name: 'Northwest Territories' },
  { code: 'NU', name: 'Nunavut' },
];

export const CITIES_BY_PROVINCE = {
  AB: ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'Airdrie', 'Cochrane', 'Okotoks', 'Medicine Hat', 'Grande Prairie', 'Fort McMurray', 'Banff', 'Canmore', 'St. Albert', 'Sherwood Park', 'Spruce Grove'],
  BC: ['Vancouver', 'Victoria', 'Kelowna', 'Surrey', 'Burnaby', 'Richmond', 'Abbotsford', 'Langley', 'Coquitlam', 'Kamloops', 'Nanaimo', 'Prince George', 'Vernon', 'Penticton', 'Chilliwack'],
  SK: ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw'],
  MB: ['Winnipeg', 'Brandon', 'Steinbach'],
  ON: ['Toronto', 'Ottawa', 'Mississauga', 'Hamilton', 'London', 'Kitchener', 'Windsor', 'Kingston', 'Barrie', 'Sudbury'],
  QC: ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Sherbrooke', 'Trois-Rivières'],
  NB: ['Moncton', 'Fredericton', 'Saint John'],
  NS: ['Halifax', 'Sydney', 'Dartmouth'],
  PE: ['Charlottetown', 'Summerside'],
  NL: ["St. John's", 'Corner Brook'],
  YT: ['Whitehorse'],
  NT: ['Yellowknife'],
  NU: ['Iqaluit'],
};

// Province → IANA timezone (primary population centre). Used to suggest the
// mover's availability timezone from their home base; the mover can change it.
export const PROVINCE_TIMEZONES = {
  AB: 'America/Edmonton',
  BC: 'America/Vancouver',
  SK: 'America/Regina',
  MB: 'America/Winnipeg',
  ON: 'America/Toronto',
  QC: 'America/Montreal',
  NB: 'America/Moncton',
  NS: 'America/Halifax',
  PE: 'America/Halifax',
  NL: "America/St_Johns",
  YT: 'America/Whitehorse',
  NT: 'America/Yellowknife',
  NU: 'America/Iqaluit',
};

export const provinceName = code => PROVINCES.find(p => p.code === code)?.name || code;

export const citiesFor = code => CITIES_BY_PROVINCE[code] || [];
